import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons";
import './SolutionIcon.scss';
import MediaQuery from "react-responsive";

const SolutionIcon = props => (
  <React.Fragment>
    <MediaQuery maxDeviceWidth={769}>
        <span className="solution-icon" onClick={props.onToggleSolution}>
          <FontAwesomeIcon icon={faCheckCircle} />
        </span>
    </MediaQuery>
    <MediaQuery minDeviceWidth={769}>
        <span className="solution-icon" onMouseEnter={props.onToggleSolution} onMouseLeave={props.onToggleSolution}>
          <FontAwesomeIcon icon={faCheckCircle} />
        </span>
    </MediaQuery>
  </React.Fragment>
);

export default SolutionIcon;
